"use client"

import { use$ } from "@legendapp/state/react"
import { useEffect, useRef } from "react"
import { usePostHog } from "posthog-js/react"
import { syncStore$ } from "@/stores/sync.v2.store"
import { getAuthenticatedPostHogIdentitySignature, identifyAuthenticatedPostHogUser } from "@/lib/posthog/identity"

export function usePosthogIdentified() {
  const posthog = usePostHog()
  const user = use$(syncStore$.userStatus)
  const account = use$(syncStore$.account)
  const lastIdentitySignatureRef = useRef<string | null>(null)

  useEffect(() => {
    if (user) {
      const identitySignature = getAuthenticatedPostHogIdentitySignature(user, account)

      if (identitySignature === lastIdentitySignatureRef.current) {
        return
      }

      const storage = typeof window !== "undefined" ? window.localStorage : null
      identifyAuthenticatedPostHogUser({
        account,
        client: posthog,
        storage,
        user,
      })
      lastIdentitySignatureRef.current = identitySignature
    } else {
      posthog.reset()
      lastIdentitySignatureRef.current = null
    }
  }, [account, user, posthog])
}
